<div class="layout-main">
  <div class="container-fluid">
    <div class="pb-2 mb-3 border-bottom">
      <h3><b>Crypto service monitoring</b></h3>
    </div>
    <div class="d-flex flex-wrap justify-content-center mb-3">
      <div class="instance-select-card">
        <label class="instance-select-label" for="instance-select">Instance</label>
        <p-dropdown (onChange)="changeSelectedInstance()" [(ngModel)]="selectedInstance"
                    [filter]="true"
                    [options]="instancesOptions"
                    [virtualScroll]="true"
                    [virtualScrollItemSize]="38"
                    scrollHeight="200px"
                    panelStyleClass="crypto-instance-panel"
                    inputId="instance-select"
                    [showClear]="true"
                    [style]="{width: instanceDropdownWidth}"
                    placeholder="Choose an instance"></p-dropdown>
      </div>
    </div>
    <div *ngIf="selectedInstance && loading" class="crypto-loading">
      <p-progressSpinner [style]="{width: '48px', height: '48px'}" animationDuration="1.2s" strokeWidth="4"></p-progressSpinner>
    </div>
    <div *ngIf="cryptoData" class="crypto-grid">
      <ng-container *ngFor="let graph of graphs; let i = index;">
        <div (click)="zoomOut(graph)" *ngIf="isZoomedIn[graph]" class="overlay"></div>
        <div [ngClass]="{'fullscreen-chart': isZoomedIn[graph]}" class="crypto-card">
          <div class="crypto-card-header">
            <span class="crypto-card-title">{{ graphsTitle[i] }}</span>
            <div class="crypto-card-actions">
              <button (click)="zoomIn(graph)" *ngIf="!isZoomedIn[graph]"
                      class="crypto-action-button" icon="pi pi-window-maximize" pButton
                      pTooltip="Zoom in" type="button"></button>
              <button (click)="zoomOut(graph)" *ngIf="isZoomedIn[graph]"
                      class="crypto-action-button" icon="pi pi-times" pButton
                      pTooltip="Zoom out" type="button"></button>
            </div>
          </div>

          <ng-container *ngIf="!loading">
            <div class="crypto-card-toolbar">
              <div class="crypto-toolbar-field">
                <label class="crypto-filter-label">Unit</label>
                <p-dropdown (onChange)="updateTimeScale(graph)"
                            [(ngModel)]="selectedUnit[graph]"
                            [options]="graphHandlerService.zoomOptions"
                            [showClear]="true"
                            placeholder="Choose a time unit">
                </p-dropdown>
              </div>
              <div class="crypto-toolbar-field">
                <label class="crypto-filter-label">Period</label>
                <p-selectButton (onChange)="updateTimeScale(graph)"
                                [(ngModel)]="selectedPeriod[graph]"
                                [options]="periods"></p-selectButton>
              </div>
              <div class="crypto-toolbar-field">
                <label class="crypto-filter-label">&nbsp;</label>
                <button (click)="resetCharZoom(graph)" class="p-button-outlined crypto-toolbar-reset"
                        label="Reset layout" pButton type="button"></button>
              </div>
            </div>

            <p-chart #chart [data]="data[graph]"
                     [id]="graph"
                     [options]="graphOptions[graph]"
                     class="crypto-chart"
                     type="line"></p-chart>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</div>
